import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget.component';
import { DashboardItemDataImage } from '../../models/DashboardItemDataImage.model';

@Component({
  selector: 'app-dashboard-image',
  templateUrl: './dashboard-image.component.html',
  styleUrls: ['./dashboard-image.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class DashboardImageComponent extends BaseWidgetComponent {
  override get data(): DashboardItemDataImage {
    return this.item.data?.image;
  }

  onImageLoaded() {
    this.itemLoaded();
  }
}
